// 9fbef606107a605d69c0edbcd8029e5d
import { BIRTHDAY_SAVING_LIST_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { createSelector } from 'reselect';
import { Map } from 'immutable';
import AccountCommonLabels, { ACCOUNT_LABELS } from '../../../labels/AccountCommon.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';

const accountLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, AccountCommonLabels);

/**
 * Selector function to retur redux BirthdaySavingListState
 * @param { object } state reduxStore state
 */
export const getBirthdaySavingListState = (state) =>
  state && state[BIRTHDAY_SAVING_LIST_REDUCER_KEY];

/**
 * Selector function to return redux BirthdaySavingList Success state
 * @param { object } state reduxStore state
 */
export const getSuccessState = createSelector(getBirthdaySavingListState, (birthdayState) =>
  birthdayState?.get('success')
);

/**
 * Selector function to return redux BirthdaySavingList error state
 * @param { object } state reduxStore state
 */
export const getErrorState = createSelector(getBirthdaySavingListState, (birthdayState) =>
  birthdayState?.get('error')
);

/**
 * Selector function to return redux BirthdaySavingList notification status
 * @param { object } state reduxStore state
 */
export const getStatus = createSelector([getSuccessState, getErrorState], (success, error) => {
  if (success) {
    return 'success';
  }

  if (error) {
    return 'error';
  }

  return '';
});

/**
 * Selector function to return redux BirthdaySavingList notification message
 * @param { object } state reduxStore state
 */
export const getMessage = createSelector([getSuccessState, getErrorState], (success, error) => {
  if (success) {
    return renderLabel(
      accountLabels?.profile?.lbl_profile_removeBirthdaySuccess,
      'lbl_profile_removeBirthdaySuccess'
    );
  }

  if (error) {
    const errorCode = Map.isMap(error) ? error.get('errorCode') : error.errorCode;

    return errorCode
      ? renderLabel(accountLabels?.profile[`lbl_profile_${errorCode}`], `lbl_profile_${errorCode}`)
      : renderLabel(accountLabels?.profile?.lbl_profile_genericError, 'lbl_profile_genericError');
  }

  return '';
});
